export default {
    "notification": {
        "title": "Benachrichtigungen",
        "showNotifications": "Zeige Benachrichtigungen",
        "hideNotifications": "Benachrichtigungen verstecken",
        "clearNotifications": "Benachrichtigungen löschen",
    }
};
